// Import Swiper and modules
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper/core';
const Swiper = SwiperCore.use([Navigation, Pagination, A11y]);

const videoSwiper = () => {
  const swiperContainer = document.querySelector('.swiper-container');
  if (typeof swiperContainer !== 'undefined' && swiperContainer !== null) {
    // Swiper
    // Install modules

    const swiper = new Swiper('.video-swiper__container', {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 1,
        },
        1200: {
          slidesPerView: 1,
        },
      },
    });

    // Fixes bug where number of slides on load is incorrect
    document.addEventListener('DOMContentLoaded', () => {
      swiper.update();
    });
  }
};

/**
 * Add ?autoplay=1 to a youtube url to trigger autoplay
 *
 * @param iframeSrcUrl
 * @return {string}
 */
const appendAutoplayParam = (iframeSrcUrl) => {
  let iframeUrl = new URL(iframeSrcUrl);
  let iframeSrcQs = iframeUrl.searchParams;
  iframeSrcQs.set('autoplay', '1');
  return iframeUrl.toString();
};

/**
 * Play the embedded iframe video on click of a post thumbnail or play icon
 */
const videoPostLink = () => {
  const postLinkPlayTriggers = '.featured-videos__play-icon, .featured-videos__video .wp-post-image';
  const videoPostLinks = document.querySelectorAll(postLinkPlayTriggers);
  if (videoPostLinks.length > 0) {
    videoPostLinks.forEach((videoPostLink) => {
      videoPostLink.addEventListener('click', (e) => {
        let videoWrapper = videoPostLink.closest('.featured-videos__video');
        videoWrapper.classList.remove('featured-videos__video--postlink');
        // autoplay the video to avoid having to click play again on the actual iframe
        let videoPlayer = videoWrapper.querySelector('iframe');
        if (videoPlayer) {
          videoPlayer.setAttribute('src', appendAutoplayParam(videoPlayer.src));
        }
      });
    });
  }
};

export { videoSwiper, videoPostLink, appendAutoplayParam };
